import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useChDeleteLaboratoryPrescriptionMutation as useChDeleteLaboratoryPrescriptionMutationType } from "@/modules/patients/detail/laboratory-prescription/ch/services/__generated__/useChDeleteLaboratoryPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useChDeleteLaboratoryPrescriptionMutation($input: Ch_deleteLaboratoryPrescriptionInput!) {
    ch_deleteLaboratoryPrescription(input: $input) {
      ch_LaboratoryPrescription {
        id @deleteRecord
      }
    }
  }
`

const useChDeleteLaboratoryPrescriptionMutation = () => {
  const [commit, isFlight] = useMutation<useChDeleteLaboratoryPrescriptionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useChDeleteLaboratoryPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useChDeleteLaboratoryPrescriptionMutation }
